import { shopifyFormatCurrency } from '@/entrypoints/utils';
import {
  LineItemPropertiesUpdateContext,
  proposeLineItemProperties,
  type LineItemPropertiesUpdateEvent,
} from '../line-item-properties-update-chain';

function needsUpdate(line: LineItemPropertiesUpdateContext['cart']['items'][number]): boolean {
  let shouldUpdate = false;

  if (line.vendor.toLowerCase().indexOf('medispa') !== -1) shouldUpdate = true;

  if (
    Object.keys(line.properties ?? {}).find(
      (key) => key.toLowerCase().indexOf('remaining amount') !== -1,
    )
  )
    shouldUpdate = true;

  return shouldUpdate;
}

export const remainingAmountRecalculationRule = (): LineItemPropertiesUpdateEvent => {
  return async (ctx) => {
    for (const line of ctx.cart.items) {
      if (!line.key) continue;

      if (!needsUpdate(line)) continue;

      const datalayerItem = ctx.lineItemsDatalayer.lineItems[String(line.id)];

      if (!datalayerItem) continue;

      const compareAtPrice = datalayerItem.discounts.reduce((acc, discount) => {
        if (discount.source === 'MEDISPA50') return acc / 2;
        return acc - discount.amount;
      }, datalayerItem.compareAtPrice ?? datalayerItem.fullPrice);

      const remainingAmount = compareAtPrice - line.final_line_price;

      // Explicitly exit if the line item's Remaining Amount already matches what we think it should be
      if (
        line.properties?.['Remaining Amount'].indexOf(
          shopifyFormatCurrency(
            remainingAmount / 100,
            '${{amount_no_decimals_with_comma_separator}}',
          ),
        ) !== -1
      )
        continue;

      proposeLineItemProperties(ctx, line.key, {
        'Remaining Amount':
          window.theme.labels.medispa.remainingAmountLineItemValueTemplate.replace(
            '{remaining_amount}',
            shopifyFormatCurrency(
              remainingAmount / 100,
              '${{amount_no_decimals_with_comma_separator}}',
            ),
          ),
      });
    }

    return ctx;
  };
};
